/* ── Geolocator web components ── */

(function () {
  'use strict';

  /* ── Cookie helpers ── */
  function setCookie(name, value, minutes) {
    document.cookie = name + '=' + value + ';max-age=' + (minutes * 60) + ';path=/';
  }

  function getCookie(name) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      if (parts[0].trim() === name) return parts[1];
    }
    return undefined;
  }

  /* ── Popover component ── */
  class GeolocatorComponent extends HTMLElement {
    async connectedCallback() {
      /* Guard: connectedCallback fires again when we move to <body> */
      if (this._initialized) return;
      this._initialized = true;

      /* Skip entirely if URL contains "b2b" */
      if (window.location.href.toLowerCase().indexOf('b2b') !== -1) {
        this.remove();
        return;
      }

      /* Check for ?edition-geoswitch param and set cookie */
      if (window.location.href.indexOf('edition-geoswitch') !== -1) {
        setCookie('edition-geoswitch', 'true', 10);
      }

      /* If cookie already exists or we're in the theme editor, don't show */
      if (getCookie('edition-geocookie') || getCookie('edition-geoswitch')) {
        this.remove();
        return;
      }
      if (window.Shopify && window.Shopify.designMode === true) {
        return;
      }

      var countryData = window.countryData || [];
      if (!countryData.length) return;

      var layout = this.dataset.layout || 'primary';

      /* Detect visitor country via Shopify's browsing context API */
      var visitorCountryCode = await this.getVisitorCountry();
      this.setAttribute('data-visitor-country', visitorCountryCode);

      /* Determine the current store from locale */
      var selectedCountry = this.getSelectedCountry(countryData);

      /* If already on the correct store, do nothing */
      if (selectedCountry && visitorCountryCode &&
          selectedCountry.countryCode.toUpperCase() === visitorCountryCode.toUpperCase()) {
        return;
      }

      /* Find matching country in our list */
      var match = null;
      var primary = null;
      for (var i = 0; i < countryData.length; i++) {
        if (countryData[i].primaryCountry) primary = countryData[i];
        if (visitorCountryCode && countryData[i].countryCode.toUpperCase() === visitorCountryCode.toUpperCase()) {
          match = countryData[i];
        }
      }

      if (!match) {
        /* Visitor from unknown country — use primary/fallback */
        if (!primary) return;
        /* If already on primary store, nothing to do */
        if (selectedCountry && selectedCountry.countryCode === primary.countryCode) return;
        match = primary;
      }

      /* Double-check via hostname */
      var currentHost = window.location.hostname;
      try {
        var matchHost = new URL(match.link).hostname;
        if (currentHost === matchHost) return;
      } catch (e) { /* keep going */ }

      if (layout === 'primary') {
        this.initPrimary(match, countryData);
      } else {
        this.initSecondary(match, countryData);
      }
    }

    async getVisitorCountry() {
      try {
        var response = await fetch('/browsing_context_suggestions.json');
        var data = await response.json();
        return data.detected_values.country.handle;
      } catch (e) {
        return '';
      }
    }

    getSelectedCountry(countryData) {
      var locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || '';
      for (var i = 0; i < countryData.length; i++) {
        if (countryData[i].locale === locale) return countryData[i];
      }
      return null;
    }

    show() {
      var self = this;
      /* Move to <body> so position:fixed is never broken by parent transforms */
      document.body.appendChild(this);
      /* Step 1: make visible but transparent (display:flex + opacity:0) */
      this.classList.add('is-ready');
      /* Step 2: force reflow, then fade in */
      void this.offsetWidth;
      setTimeout(function () {
        self.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }, 500);

      /* Dismiss on backdrop click */
      this.addEventListener('click', function (e) {
        if (e.target === self) self.dismiss();
      });
    }

    dismiss() {
      var self = this;
      this.classList.remove('is-visible');
      document.body.style.overflow = '';
      setCookie('edition-geocookie', 'true', 10);
      setTimeout(function () {
        self.remove();
      }, 400);
    }

    initPrimary(match) {
      var self = this;

      var flag = this.querySelector('#geolocator-flag');
      var heading = this.querySelector('#geolocator-heading');
      var richtext = this.querySelector('#geolocator-richtext');
      var btnStay = this.querySelector('#geolocator-button-stay');
      var btnRedirect = this.querySelector('#geolocator-button-redirect');

      if (flag && match.flag) flag.src = match.flag;
      if (flag && !match.flag) flag.style.display = 'none';
      if (heading) heading.textContent = match.heading || '';
      if (richtext) richtext.innerHTML = match.richtext || '';
      if (btnStay) btnStay.textContent = match.button_two || 'Stay';
      if (btnRedirect) btnRedirect.textContent = match.button_one || 'Go';

      if (btnStay) {
        btnStay.addEventListener('click', function () {
          self.dismiss();
        });
      }

      if (btnRedirect) {
        btnRedirect.addEventListener('click', function () {
          self.remove();
          if (match.type === 'Market') {
            self.updateLocalization(match.countryCode, match.locale);
          } else {
            window.location.href = match.link;
          }
        });
      }

      this.show();
    }

    initSecondary(match, countryData) {
      var self = this;
      var heading = this.querySelector('#geolocator-heading');
      var richtext = this.querySelector('#geolocator-richtext');
      var btnStay = this.querySelector('#geolocator-button-stay');

      if (heading) heading.textContent = match.heading || '';
      if (richtext) richtext.innerHTML = match.richtext || '';
      if (btnStay) {
        btnStay.textContent = match.button_two || 'Stay';
        btnStay.addEventListener('click', function () {
          self.dismiss();
        });
      }

      /* Sort so matched country appears first */
      this.sortCountries(match);

      this.show();
    }

    sortCountries(match) {
      var listHolder = this.querySelector('#geolocator-country-list');
      if (!listHolder) return;
      var items = Array.from(listHolder.querySelectorAll('.geolocator-country'));
      items.sort(function (a, b) {
        if (a.dataset.locale === match.locale) return -1;
        if (b.dataset.locale === match.locale) return 1;
        return 0;
      });
      items.forEach(function (item) {
        listHolder.appendChild(item);
      });
    }

    updateLocalization(countryCode, countryLocale) {
      var id = Math.random().toString(36).substring(7);
      var html = '<form id="' + id + '" action="/localization" method="POST" hidden>' +
        '<input name="_method" value="PUT">' +
        '<input name="country_code" value="' + countryCode + '">' +
        '<input name="language_code" value="' + countryLocale + '">' +
        '</form>';
      document.body.insertAdjacentHTML('beforeend', html);
      document.getElementById(id).submit();
    }
  }

  if (!customElements.get('geolocator-component')) {
    customElements.define('geolocator-component', GeolocatorComponent);
  }

  /* ── Dropdown component ── */
  class EditionGeodropdown extends HTMLElement {
    connectedCallback() {
      var self = this;
      var trigger = this.querySelector('#edition-geodropdown_trigger');
      var list = this.querySelector('#edition-geodropdown_list');
      var placement = this.dataset.placementtarget;

      if (!trigger || !list) return;

      /* Set trigger text to current locale country */
      var triggerText = trigger.querySelector('[triggertext]');
      if (triggerText) {
        var items = list.querySelectorAll('.geodropdown__item');
        for (var i = 0; i < items.length; i++) {
          if (items[i].dataset.selected === 'true') {
            triggerText.textContent = items[i].dataset.country || '';
            break;
          }
        }
      }

      /* Move to target placement */
      if (placement) {
        var target = document.querySelector(placement);
        if (target) target.appendChild(self);
      }

      /* Toggle */
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = list.classList.toggle('is-open');
        list.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      /* Close on outside click */
      document.addEventListener('click', function () {
        list.classList.remove('is-open');
        list.setAttribute('aria-expanded', 'false');
      });
    }
  }

  if (!customElements.get('edition-geodropdown')) {
    customElements.define('edition-geodropdown', EditionGeodropdown);
  }
})();
